import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({ selected, onChange, messageId, ...props }) => (
    <label className="checkbox" {...props}>
        <input type="checkbox" value={selected} onChange={onChange} />
        <FormattedMessage id={messageId}>
            {(message) => (
                <span
                    style={{
                        marginLeft: '1rem',
                    }}
                >
                    {message}
                </span>
            )}
        </FormattedMessage>
    </label>
);



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/Checkbox.js